exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-dd7ff47a]{width:1em;height:1em;vertical-align:-0.15em;fill:currentColor;overflow:hidden}\n", ""]);

// exports
